import SEO from '../components/SEO';
import { Eyebrow } from '../components/Reveal';

const CONTENT = {
  privacy: {
    title: 'Privacy Policy',
    seo: 'Privacy Policy | INSIGHTS STRATEGY',
    desc: 'How INSIGHTS STRATEGY, a division of Kalpataru Enterprise, collects, uses and protects personal information.',
    path: '/privacy-policy',
    sections: [
      ['Overview', 'INSIGHTS STRATEGY, a division of Kalpataru Enterprise ("we", "our"), respects the privacy of visitors to this website. This policy explains what information we collect and how we use it. This document is an editable draft and should be reviewed by legal counsel before reliance.'],
      ['Information We Collect', 'When you submit an enquiry through our contact form, we collect your name, organisation, business email, optional phone number, service of interest, project location and project description, together with your consent. We do not collect payment information or sensitive personal data through this website.'],
      ['How We Use Information', 'Information submitted through the contact form is used solely to respond to your enquiry and to manage our relationship with you. Enquiry details are stored securely and notified to our team by email. We do not sell, rent or share your personal information with third parties for their marketing purposes.'],
      ['Data Retention & Security', 'Enquiry records are retained only as long as necessary to respond to and manage your enquiry, after which they may be deleted. Access to submitted information is restricted to authorised administrators through an authenticated interface.'],
      ['Your Rights', 'You may request access to, correction of, or deletion of your personal information at any time by writing to info@insightsstrategy.in.'],
      ['Contact', 'For any privacy-related questions, contact us at info@insightsstrategy.in. INSIGHTS STRATEGY, A Division of Kalpataru Enterprise, Kolkata, West Bengal, India.'],
    ],
  },
  terms: {
    title: 'Terms of Use',
    seo: 'Terms of Use | INSIGHTS STRATEGY',
    desc: 'Terms governing the use of the INSIGHTS STRATEGY website, a division of Kalpataru Enterprise.',
    path: '/terms-of-use',
    sections: [
      ['Acceptance of Terms', 'By accessing this website, you agree to these Terms of Use. This document is an editable draft and should be reviewed by legal counsel before reliance.'],
      ['About This Website', 'This website is operated by INSIGHTS STRATEGY, a division of Kalpataru Enterprise, Kolkata, West Bengal, India. Content on this website is provided for general information about our research, consulting and advisory capabilities.'],
      ['No Professional Advice', 'Content on this website does not constitute professional, legal, financial or investment advice. Engagement-specific advice is provided only under a formal agreement.'],
      ['Accuracy of Content', 'We take care to publish only verified information. Where institutional experience of the parent organisation, Kalpataru Enterprise, is referenced, it is identified as such. We do not publish client names, engagement results or research findings without authorisation.'],
      ['Intellectual Property', 'All content, branding and materials on this website are the property of Kalpataru Enterprise / INSIGHTS STRATEGY and may not be reproduced without written permission.'],
      ['Contact', 'Questions about these terms may be directed to info@insightsstrategy.in.'],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <>
      <SEO title={c.seo} description={c.desc} path={c.path} />
      <section className="bg-brand-deep" data-testid={`${kind}-hero`}>
        <div className="mx-auto max-w-4xl px-5 pb-16 pt-40 lg:px-8">
          <Eyebrow dark>Legal</Eyebrow>
          <h1 className="mt-6 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{c.title}</h1>
          <p className="mt-4 text-xs text-white/45">Last updated: 2026 · Editable draft pending legal review</p>
        </div>
      </section>
      <section className="bg-brand-offwhite">
        <div className="mx-auto max-w-4xl space-y-10 px-5 py-16 lg:px-8 lg:py-20" data-testid={`${kind}-content`}>
          {c.sections.map(([h, body]) => (
            <div key={h}>
              <h2 className="font-heading text-lg font-bold text-brand-black">{h}</h2>
              <p className="mt-3 text-sm leading-[1.9] text-brand-body">{body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
